<template>
  <div class="card-slideshow">
    <div class="container-wrapper">
      <div class="wrapper">
        <div ref="wrapperSlides" class="wrapper-slides">
          <a
            v-for="(slide, i) in slides"
            :id="`slide-${i}`"
            :key="`slide-${i}`"
            class="slide p-sm"
            :class="{ 'is-active': i === activeItem }"
            @click="activeItem = i"
            @focus="activeItem = i"
          >
            <slot name="slide" :slide="slide" :active="i === activeItem"></slot>
          </a>
        </div>
      </div>
    </div>
    <div class="control">
      <b-slider
        class="control-line"
        v-model="sliderValue"
        :min="minSlider"
        :max="maxSlider"
        type="is-white"
        :tooltip="hasTooltip"
        @change="sliderChange"
        ticks
      >
      </b-slider>
      <div class="slide-count m-l-lg">
        {{ activeItem + 1 }}/{{ slides.length }}
      </div>
    </div>
    <!-- <div class="help-message m-t-md">
      Desliza hacia los lados para navegar entre propiedades
    </div> -->
  </div>
</template>

<script>
const maxMobileWidth = 768;
const mobileSlideWidth = 250;
const desktopSlideWidth = 363;

export default {
  name: "CardSlideshow",

  props: {
    slides: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      hasTooltip: false,
      activeItem: 0,
      pastActiveItem: 0,
      sliderValue: 0,
      minSlider: 1,
      maxSlider: 1,
      itemWidth: desktopSlideWidth
    };
  },

  watch: {
    slides(newVal) {
      this.maxSlider = newVal.length;
    }
  },

  mounted() {
    this.addScroll();
    this.setSlideWidth();
  },

  beforeDestroy() {
    this.removeScroll();
  },

  methods: {
    sliderChange(index) {
      this.pastActiveItem = this.activeItem;
      this.activeItem = index - 1;
      if (this.activeItem > this.pastActiveItem) {
        this.forceScrollRight();
      } else {
        this.forceScrollLeft();
      }
    },

    handleScroll(e) {},

    forceScrollRight() {
      this.$refs.wrapperSlides.scrollLeft += this.slideWidth;
    },

    forceScrollLeft() {
      this.$refs.wrapperSlides.scrollLeft -= this.slideWidth;
    },

    addScroll() {
      this.$refs.wrapperSlides.addEventListener("scroll", this.handleScroll);
    },

    removeScroll() {
      this.$refs.wrapperSlides.removeEventListener("scroll", this.handleScroll);
    },

    setSlideWidth() {
      if (window.innerWidth <= maxMobileWidth) {
        this.slideWidth = mobileSlideWidth;
      } else {
        this.slideWidth = desktopSlideWidth;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-slideshow {
  position: relative;
  height: 100% !important;
  width: 100% !important;
  overflow-y: hidden !important;
}

.container-wrapper {
  height: 520px;
}

.wrapper {
  position: relative;
  height: 100% !important;
  overflow-y: auto !important;
  white-space: nowrap !important;
  overflow-x: scroll !important;
  padding-bottom: 30px !important;
  -webkit-overflow-scrolling: touch;
}

.wrapper-slides {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  height: 470px;
  -webkit-overflow-scrolling: touch;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE and Edge */
  -ms-overflow-style: none;
}

.wrapper-slides::-webkit-scrollbar {
  display: none;
}

.slide {
  margin-right: 1em;
  width: 250px;
  max-width: 100%;
  transition: all 0.3s;
  scroll-snap-align: start;
}

.control {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

  .control-line {
    width: 300px;
  }
}

.slide-count {
  color: rgba(255, 255, 255, 0.65);
}

.slide-count {
  text-align: center;
  vertical-align: middle;

  margin-top: 0.4rem;
}

/deep/.b-slider .b-slider-thumb {
  width: 2rem;
}

/deep/.b-slider .b-slider-track {
  background: rgba(255, 255, 255, 0.25);
}

@media only screen and (min-width: 769px) {
  .slide {
    width: 376px;
    margin-right: 0em;
  }

  .slide-count {
    text-align: center;
    vertical-align: middle;
  }
}
</style>
